export var QuoteRecoverySourceEnum;

(function (QuoteRecoverySourceEnum) {
  QuoteRecoverySourceEnum["Normal"] = "normal";
  QuoteRecoverySourceEnum["Cms"] = "cms";
  QuoteRecoverySourceEnum["CopyLink"] = "copylink";
  QuoteRecoverySourceEnum["Email"] = "email";
  QuoteRecoverySourceEnum["QuoteSwitchInsurer"] = "quoteSwitchInsurer";
})(QuoteRecoverySourceEnum || (QuoteRecoverySourceEnum = {}));

export var QuoteFlowModeEnum;

(function (QuoteFlowModeEnum) {
  QuoteFlowModeEnum["normal"] = "standard";
  QuoteFlowModeEnum["fastTrack"] = "vanilla";
})(QuoteFlowModeEnum || (QuoteFlowModeEnum = {}));

export var QuoteChangeProviderEnum;

(function (QuoteChangeProviderEnum) {
  QuoteChangeProviderEnum["quote"] = "quote";
  QuoteChangeProviderEnum["cmsManual"] = "cmsManual";
  QuoteChangeProviderEnum["cmsAuto"] = "cmsAuto";
})(QuoteChangeProviderEnum || (QuoteChangeProviderEnum = {}));

export var QuoteFromPageSourceEnum;

(function (QuoteFromPageSourceEnum) {
  QuoteFromPageSourceEnum["msp"] = "msp";
  QuoteFromPageSourceEnum["websiteRecruitment"] = "websiteRecruitment";
})(QuoteFromPageSourceEnum || (QuoteFromPageSourceEnum = {}));

export var QuoteBusinessSourceEnum;

(function (QuoteBusinessSourceEnum) {
  QuoteBusinessSourceEnum["quote"] = "quote";
  QuoteBusinessSourceEnum["broker"] = "broker";
  QuoteBusinessSourceEnum["partner"] = "partner";
  QuoteBusinessSourceEnum["policy"] = "policy";
  QuoteBusinessSourceEnum["brokerQuote"] = "brokerQuote";
  QuoteBusinessSourceEnum["brokerDetailInfoView"] = "brokerDetailInfoView";
  QuoteBusinessSourceEnum["coversation"] = "coversation";
  QuoteBusinessSourceEnum["brokerPolicy"] = "brokerPolicy";
  QuoteBusinessSourceEnum["portalPolicy"] = "portalPolicy";
})(QuoteBusinessSourceEnum || (QuoteBusinessSourceEnum = {}));

export var QuotePlatformSourceEnum;

(function (QuotePlatformSourceEnum) {
  QuotePlatformSourceEnum["admin"] = "admin";
  QuotePlatformSourceEnum["portal"] = "portal";
})(QuotePlatformSourceEnum || (QuotePlatformSourceEnum = {}));

export var QuotePageUniversalDataSourceTypeEnum;

(function (QuotePageUniversalDataSourceTypeEnum) {
  QuotePageUniversalDataSourceTypeEnum["totalCostClaims"] = "totalCostClaims";
  QuotePageUniversalDataSourceTypeEnum["totalInsurancePremiumPaid"] = "totalInsurancePremiumPaid";
  QuotePageUniversalDataSourceTypeEnum["businessExpectedRevenue"] = "businessExpectedRevenue";
  QuotePageUniversalDataSourceTypeEnum["claimAdjustersEstimateClaimsNumber"] = "claimAdjustersEstimateClaimsNumber";
  QuotePageUniversalDataSourceTypeEnum["claimAdjustersEstimateClaimsAverageValue"] = "claimAdjustersEstimateClaimsAverageValue";
  QuotePageUniversalDataSourceTypeEnum["approximatelyBusiness"] = "approximatelyBusiness";
  QuotePageUniversalDataSourceTypeEnum["workRequireCertifiedPercentage"] = "workRequireCertifiedPercentage";
  QuotePageUniversalDataSourceTypeEnum["writtenContractPercentage"] = "writtenContractPercentage";
  QuotePageUniversalDataSourceTypeEnum["subcontractorPercentage"] = "subcontractorPercentage";
  QuotePageUniversalDataSourceTypeEnum["staffExperienceYears"] = "staffExperienceYears";
  QuotePageUniversalDataSourceTypeEnum["squareFeetOccupiedByYou"] = "squareFeetOccupiedByYou";
  QuotePageUniversalDataSourceTypeEnum["numOfOwners"] = "numOfOwners";
  QuotePageUniversalDataSourceTypeEnum["estmtdPayrollExpense"] = "estmtdPayrollExpense";
})(QuotePageUniversalDataSourceTypeEnum || (QuotePageUniversalDataSourceTypeEnum = {}));